/** Voice picker: per-language voice list, persisted choice, locked during calls. */
import { DEFAULT_VOICE_ID, VOICE_STORAGE_KEY, voiceOptions } from "./voices";

export type VoicePicker = {
  voiceId: () => string;
  setLocked: (params: { locked: boolean }) => void;
};

export const setupVoicePicker = (): VoicePicker => {
  const picker = document.querySelector(".voice-picker") as HTMLLabelElement;
  const select = document.getElementById("voice-select") as HTMLSelectElement;

  for (const voice of voiceOptions) {
    const option = document.createElement("option");
    option.value = voice.id;
    option.textContent = voice.label;
    select.append(option);
  }
  select.value = localStorage.getItem(VOICE_STORAGE_KEY) ?? DEFAULT_VOICE_ID;
  if (!voiceOptions.some((voice) => voice.id === select.value)) {
    select.value = DEFAULT_VOICE_ID;
  }
  select.addEventListener("change", () => {
    localStorage.setItem(VOICE_STORAGE_KEY, select.value);
  });

  return {
    voiceId: () => select.value,
    setLocked: ({ locked }) => {
      picker.dataset.locked = String(locked);
    },
  };
};
